import { postFetch } from '../fetch';
import { apiConfig } from '../config';

interface GptRequest {
    text: string;
    threadId?: string | null | undefined;
}

interface GptResponse {
    text: string;
    thread_id: string;
}

export function postGptHelp(msg: GptRequest): Promise<GptResponse> {
    const { apiPostGptHelp } = apiConfig.getStaticUrls();

    return postFetch(apiPostGptHelp, msg);
}
